export default DetalheController;

/** @ngInject */
function DetalheController($stateParams, Empresas, Fretes) {

  let vm = this;

  this.filtro = {
    nm_base: $stateParams.nm_base,
    cd_pessoa: $stateParams.cd_pessoa
  };

  this.mostrarFretes = Empresas.tabIndex === 1;

  this.tabIndex = Empresas.tabIndex;
  this.setarTabIndex = (index) => Empresas.tabIndex = index;
  this.buscarFretes = () => {
    this.setarTabIndex(1);
    this.mostrarFretes = true;
  };

  Fretes.setarCacheId('empresas');

  buscarEmpresa();

  function buscarEmpresa() {
    vm.empresa = undefined;
    vm.buscandoEmpresa = true;

    Empresas
      .buscarDadosEmpresa(vm.filtro)
      .then(empresa => {
        vm.empresa = empresa;
        vm.buscandoEmpresa = false;
      });
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/empresas/detalhe.controller.ts
 **/